import { ActionBanner, Button, TOUCH } from "@nymbl/nos2-rules";

/** Shown only while there is something to approve (DECISIONS: alerts only when actionable). */
export function ExpenseBanner({ count, onReview }: { count: number; onReview: () => void }) {
  if (count <= 0) return null;
  return (
    <ActionBanner
      action={
        <Button size="sm" className={TOUCH} onClick={onReview} aria-label="Review expenses">
          Review
        </Button>
      }
    >
      {count} {count === 1 ? "expense" : "expenses"} to approve
    </ActionBanner>
  );
}
